let lastScrollTop = 0; // Store the last scroll position
const scrollThreshold = 1500; // Threshold to trigger hide/show behavior

window.addEventListener('scroll', () => {
    // Target buttons
    const chatButton = document.querySelector('#shopify-chat'); // Example button
    const smileButtonContainer = document.querySelector('#smile-ui-lite-launcher-frame-container'); // Smile button container

    // Get current scroll position
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Check if scroll distance exceeds the threshold
    if (Math.abs(currentScrollTop - lastScrollTop) > scrollThreshold) {
        if (currentScrollTop > lastScrollTop) {
            // Scroll down - hide buttons
            if (chatButton) {
                chatButton.classList.add('hidden');
            }
            if (smileButtonContainer) {
                smileButtonContainer.classList.add('hidden');
            }
        } else {
            // Scroll up - show buttons
            if (chatButton) {
                chatButton.classList.remove('hidden');
            }
            if (smileButtonContainer) {
                smileButtonContainer.classList.remove('hidden');
            }
        }

        // Update the last scroll position
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Ensure it doesn't go negative
    }
});